import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const NetRedux = createActions({
  NetExcelRequest: [''],
  NetExcelSuccess: [''],
  NetExcelError: ['error'],
},
{
  prefix: 'NET_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = NetRedux
export const NetTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const NetExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const NetExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const NetExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.NetExcelRequest]: NetExcelRequest,
  [Types.NetExcelSuccess]: NetExcelSuccess,
  [Types.NetExcelError]: NetExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/NetRedux.js